function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1960(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.5,
    height: 1.52,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.25333333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 0.76
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.52,
    width: 8.5,
    height: 10.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 6.975
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.43,
    width: 8.5,
    height: 12.18,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 18.52
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.62,
    width: 8.5,
    height: 26.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 37.75
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50.87,
    width: 8.5,
    height: 31.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 66.6
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.33,
    width: 8.5,
    height: 32.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2142857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 98.715
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.1,
    width: 8.5,
    height: 43.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 136.64
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 158.18,
    width: 8.5,
    height: 43.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 179.835
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 201.48,
    width: 8.5,
    height: 47.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9444444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 225.23499999999999
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 248.99,
    width: 8.5,
    height: 47.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 272.82
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 296.65,
    width: 8.5,
    height: 48.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 320.66499999999996
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 344.68,
    width: 8.5,
    height: 52.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 370.72
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 396.76,
    width: 8.5,
    height: 52.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 423.09999999999997
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 449.44,
    width: 8.5,
    height: 55.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9444444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 477.325
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 505.21,
    width: 8.5,
    height: 63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 536.71
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 568.21,
    width: 8.5,
    height: 65.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 600.8050000000001
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 633.4,
    width: 8.5,
    height: 66.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.25,
    y: 666.6999999999999
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0,
    width: 20.87,
    height: 36.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4783333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.935000000000002,
    y: 18.295
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.37,
    y: 0,
    width: 21.06,
    height: 36.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.9,
    y: 18.295
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.43,
    y: 0,
    width: 22.75,
    height: 36.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7916666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.805,
    y: 18.295
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.17,
    y: 0,
    width: 24.6,
    height: 36.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.47,
    y: 18.295
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.78,
    y: 0,
    width: 25.39,
    height: 36.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.821111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.475,
    y: 18.295
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.17,
    y: 0,
    width: 28.93,
    height: 36.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.821666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.635,
    y: 18.295
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.1,
    y: 0,
    width: 30.09,
    height: 36.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.76125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.14499999999998,
    y: 18.295
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.18,
    y: 0,
    width: 34,
    height: 36.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.18,
    y: 18.295
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.19,
    y: 0,
    width: 38.84,
    height: 36.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.065555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.61,
    y: 18.295
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.02,
    y: 0,
    width: 40.76,
    height: 36.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.57375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.40000000000003,
    y: 18.295
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 0,
    width: 46.49,
    height: 36.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.035,
    y: 18.295
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.28,
    y: 0,
    width: 49.11,
    height: 36.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.835,
    y: 18.295
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.39,
    y: 0,
    width: 50.01,
    height: 36.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.395,
    y: 18.295
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.4,
    y: 0,
    width: 56.9,
    height: 36.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.84999999999997,
    y: 18.295
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.3,
    y: 0,
    width: 59.23,
    height: 36.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.915,
    y: 18.295
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.52,
    y: 0,
    width: 68.03,
    height: 36.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4393333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.535,
    y: 18.295
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.55,
    y: 0,
    width: 74.45,
    height: 36.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.3180000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.775,
    y: 18.295
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 36.59,
    width: 64.7,
    height: 45.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.62875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 59.105000000000004
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 81.63,
    width: 64.7,
    height: 48.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.854
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 105.89999999999999
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 130.17,
    width: 64.7,
    height: 53.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 156.86499999999998
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 183.56,
    width: 64.7,
    height: 63.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.588333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 215.325
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 247.08,
    width: 64.7,
    height: 69.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 281.65500000000003
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 316.24,
    width: 64.7,
    height: 70.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.470000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 351.675
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 387.11,
    width: 64.7,
    height: 74.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 424.375
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 461.64,
    width: 64.7,
    height: 76.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.940000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 499.855
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 538.07,
    width: 64.7,
    height: 79.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.976923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 577.8800000000001
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 617.68,
    width: 64.7,
    height: 82.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.242857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.85,
    y: 658.8399999999999
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 36.59,
    width: 70.68,
    height: 97.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.425454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.54,
    y: 85.415
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.88,
    y: 36.59,
    width: 80.75,
    height: 97.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.1875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.255,
    y: 85.415
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.63,
    y: 36.59,
    width: 90.44,
    height: 97.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.04888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.85,
    y: 85.415
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.07,
    y: 36.59,
    width: 100.8,
    height: 97.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.275000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.46999999999997,
    y: 85.415
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.87,
    y: 36.59,
    width: 136.59,
    height: 97.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.137500000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.165,
    y: 85.415
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.46,
    y: 36.59,
    width: 147.54,
    height: 97.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.23,
    y: 85.415
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 134.25,
    width: 124.42,
    height: 117.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.788
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.41,
    y: 193.19
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 252.13,
    width: 124.42,
    height: 122.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.602222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.41,
    y: 313.34
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 374.55,
    width: 124.42,
    height: 151.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.31090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.41,
    y: 450.24
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 525.92,
    width: 124.42,
    height: 174.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.736666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.41,
    y: 612.9599999999999
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.62,
    y: 134.25,
    width: 150.86,
    height: 170.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.604615384615386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.05,
    y: 219.67000000000002
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.48,
    y: 134.25,
    width: 174.31,
    height: 170.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.982222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.635,
    y: 219.67000000000002
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.79,
    y: 134.25,
    width: 177.21,
    height: 170.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.405714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.395,
    y: 219.67000000000002
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.62,
    y: 305.08,
    width: 502.38,
    height: 394.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.901818181818186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.81,
    y: 502.53999999999996
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1960);
export default __webpack_public_path__ + "static/media/1960.c3b50a7f47603edb784261f57a3852ec.svg";
export { ForwardRef as ReactComponent };